import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { getSavedCustomerToken, getCustomerProfile } from '@/lib/shopifyCustomer';
import { toast } from 'sonner';

const ProfilePage = () => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadProfile() {
      try {
        const token = getSavedCustomerToken();

        if (!token) {
          setLoading(false);
          return;
        }

        const data = await getCustomerProfile(token);

        if (!data) {
          toast.error('Sessão inválida. Faça login novamente.');
          setLoading(false);
          return;
        }

        setCustomer(data);
      } catch (error) {
        void error;
        toast.error('Erro ao carregar perfil');
      } finally {
        setLoading(false);
      }
    }

    loadProfile();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen pt-24 pb-16 px-6">
        <div className="max-w-[1000px] mx-auto flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
        </div>
      </div>
    );
  }

  if (!customer) {
    return null;
  }

  return (
    <div className="min-h-screen pt-24 pb-16 px-6">
      <div className="max-w-[1000px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12"
        >
          <h1 className="font-heading text-5xl font-bold text-text-primary mb-4">
            Meu Perfil
          </h1>
          <p className="text-lg text-text-secondary">
            Veja suas informações cadastradas na Aura Rosa.
          </p>
        </motion.div>

        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-10 space-y-8">
          <div>
            <h2 className="font-heading text-3xl font-bold mb-6 text-text-primary">
              Informações da Conta
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <p className="text-sm text-text-muted mb-1">Nome</p>
                <p className="text-lg text-text-primary">
                  {customer.displayName || `${customer.firstName || ''} ${customer.lastName || ''}`.trim() || '—'}
                </p>
              </div>

              <div>
                <p className="text-sm text-text-muted mb-1">E-mail</p>
                <p className="text-lg text-text-primary">{customer.email || '—'}</p>
              </div>

              <div>
                <p className="text-sm text-text-muted mb-1">Telefone</p>
                <p className="text-lg text-text-primary">{customer.phone || '—'}</p>
              </div>

              <div>
                <p className="text-sm text-text-muted mb-1">Pedidos realizados</p>
                <p className="text-lg text-text-primary">{customer.numberOfOrders ?? 0}</p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="font-heading text-3xl font-bold mb-6 text-text-primary">
              Endereço Principal
            </h2>

            {customer.defaultAddress ? (
              <div className="space-y-2 text-lg text-text-secondary">
                <p>{customer.defaultAddress.address1 || '—'}</p>
                {customer.defaultAddress.address2 && <p>{customer.defaultAddress.address2}</p>}
                <p>
                  {customer.defaultAddress.city || ''} {customer.defaultAddress.province ? `- ${customer.defaultAddress.province}` : ''}
                </p>
                <p>{customer.defaultAddress.zip || '—'}</p>
                <p>{customer.defaultAddress.country || '—'}</p>
              </div>
            ) : (
              <p className="text-lg text-text-secondary">Nenhum endereço principal cadastrado.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;